import { useHasFilters, useHighlightIds } from 'map-filter-view'
import { getFilterPayload } from 'map-style-utils'
import { useMemo } from 'react'

export const useLayerFilter = () => {
  const hasFilters = useHasFilters()
  const highlightIds = useHighlightIds()

  const payload = useMemo(
    () =>
      // prettier-ignore
      hasFilters 
        ? getFilterPayload(highlightIds)
        : {},
    [hasFilters, highlightIds]
  )

  return payload
}
